import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../framework/customStore";

import { AnyAction } from "@reduxjs/toolkit";
import MuiRadioGroup, {
    IMuiRadioGroupOption,
} from "../../framework/muiRadioGroup";
import { useTranslation } from "react-i18next";
import { DisplayMode } from "../../../models/reporting/reportTemplate";
import Stack from "@mui/material/Stack";
import { NumberInput } from "../../framework/numberInput";

interface Column {
    id: string;
    title: string;
}

export interface ColumnGroup {
    label: string;
    columns: Column[];
}

interface Props {
    mode: DisplayMode;
    decimals: number;
    setDisplayMode: (val: DisplayMode) => AnyAction;
    setDecimals: (val: number) => AnyAction;
}

export const ReportDisplayOptions = ({
    mode,
    decimals: reportDecimals,
    setDisplayMode,
    setDecimals: setReportDecimals,
}: Props) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [decimals, setDecimals] = useState<string | number>(reportDecimals);

    useEffect(() => {
        if (reportDecimals !== decimals) {
            setDecimals(reportDecimals);
        }
    }, [reportDecimals]);

    useEffect(() => {
        if (
            (!!decimals || decimals === 0) &&
            (decimals as number) >= 0 &&
            (decimals as number) <= 4 &&
            reportDecimals !== decimals
        ) {
            // Only update report decimals if defined and changed
            dispatch(setReportDecimals(decimals as number));
        }
    }, [decimals]);

    const options: IMuiRadioGroupOption[] = useMemo(
        () => [
            {
                label: t("common.displayOptions.hoursAndMinutes"),
                value: DisplayMode.Hours,
            },
            {
                label: t("common.displayOptions.decimals"),
                value: DisplayMode.Decimals,
            },
        ],
        []
    );

    return (
        <Stack direction="row">
            <MuiRadioGroup
                value={mode}
                options={options}
                onChange={(val) => dispatch(setDisplayMode(val as DisplayMode))}
                row
            />
            <NumberInput
                value={decimals}
                onChange={setDecimals}
                min={0}
                max={4}
                size="small"
                sx={{ width: 60 }}
            />
        </Stack>
    );
};
